import type { OctopusFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { OpenFeature } from "@openfeature/web-sdk";
import { useMemo } from "react";
import * as React from "react";
import { useLocation } from "react-router-dom";
import type { ProjectStatus } from "~/areas/projects/components/ProjectStatus/useProjectStatus";
import { session } from "~/clientInstance";
import { NotFound, stateFor404Redirect } from "~/components/NotFound/NotFound";
import type { SpaceContext } from "~/components/SpaceLoader/SpaceLoader";
import { AllPageRoutes } from "~/routing/AllPageRoutes";
import type { StandardLoaderContext } from "~/routing/pageRegistrations/StandardLoaderContext";
import type { StandardPageContext } from "~/routing/pageRegistrations/StandardPageContext";
interface RootRoutesProps {
    spaceContext: SpaceContext;
    scrollAreaRef: React.RefObject<HTMLDivElement>;
    projectStatus: ProjectStatus;
}
function isOctopusFeatureToggleEnabled(toggle: OctopusFeatureToggle, defaultValue: boolean) {
    const client = OpenFeature.getClient();
    return client.getBooleanValue(toggle, defaultValue);
}
function RootRoutes({ spaceContext, scrollAreaRef, projectStatus }: RootRoutesProps) {
    const standardLoaderContext: StandardLoaderContext = useMemo(() => {
        if (session.currentUser === null) {
            throw new Error("Can't setup page loader context because the user is unexpectedly null");
        }
        return {
            currentUser: session.currentUser,
            isOctopusFeatureToggleEnabled: isOctopusFeatureToggleEnabled,
        };
    }, []);
    const standardPageContext: StandardPageContext = useMemo(() => {
        if (session.currentUser === null) {
            throw new Error("Can't setup page context because the user is unexpectedly null");
        }
        return {
            currentUser: session.currentUser,
            scrollAreaRef,
            projectStatus,
        };
    }, [projectStatus, scrollAreaRef]);
    const location = useLocation();
    if (location.state === stateFor404Redirect) {
        return <NotFound />;
    }
    return <AllPageRoutes spaceContext={spaceContext} loaderContext={standardLoaderContext} pageContext={standardPageContext}/>;
}
export default RootRoutes;
